import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsertRowBelowIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 3.1665H11.7333C9.49312 3.1665 8.37302 3.1665 7.51737 3.60248C6.76472 3.98597 6.1528 4.59789 5.76931 5.35054C5.33333 6.20619 5.33333 7.32629 5.33333 9.5665V13.8332M5.33333 13.8332L8.66667 10.4998M5.33333 13.8332L2 10.4998",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgInsertRowBelowIcon;
